export const ADMIN_EMAIL = 'admin@psagchurch.org';

export function isAdminEmail(email) {
  return email?.trim().toLowerCase() === ADMIN_EMAIL;
}

export function getActorRole(email) {
  return isAdminEmail(email) ? 'admin' : 'member';
}
